import type { Locale } from 'lc-services/types'

export const toFacetMap = (facets?: Readonly<(string | undefined)[]>) =>
  new Map(
    facets?.filter(Boolean).map((str) =>
      str!
        .split(':')
        .reverse()
        .map((str) => str.trim()),
    ) as [string, string][],
  )

export const toFacetQuery = (
  locale: Locale,
  facets?: Record<Locale, Record<string, string[]>>,
) => ({
  facetFilter: Object.values(facets?.[locale] ?? {})
    .map((value) => value[0])
    .filter(Boolean),
})
